<script>
	import { Route, Router } from "svelte-routing";
	import AppBreadcrumb from "../components/AppBreadcrumb/AppBreadcrumb.svelte";
	import CustomToast from "../components/CustomToast/CustomToast.svelte";
	import VersionModal from "../components/VersionModal/VersionModal.svelte";
	import Sidebar from "../components/Sidebar/Sidebar.svelte";
	import { toastMessage, userRole } from "../store/store";
	import Account from "../views/Account/Account.svelte";
	import BlackoutManagement from "../views/BlackoutManagement/BlackoutManagement.svelte";
	import CarManagement from "../views/CarManagement/CarManagement.svelte";
	import CarparkManagement from "../views/CarparkManagement/CarparkManagement.svelte";
	import Dashboard from "../views/Dashboard.svelte";
	import EvAccManagement from "../views/EvAccManagement/EvAccManagement.svelte";
	import EvManagement from "../views/EvManagement/EvManagement.svelte";
	import FuelCardManagement from "../views/FuelCardManagement/FuelCardManagement.svelte";
	import IssueManagement from "../views/IssueManagement/IssueManagement.svelte";
	import Issues from "../views/Issues/Issues.svelte";
	import JobManagement from "../views/JobManagement/JobManagement.svelte";
	import MaintenanceRepair from "../views/MaintenanceRepair/MaintenanceRepair.svelte";
	import MasterData from "../views/MasterData/MasterData.svelte";
	import NotFound from "../views/NotFound.svelte";
	import Servicing from "../views/Servicing/Servicing.svelte";
	import { brand } from "src/brand";
	import { isMnrEnabled } from "src/config/flag-config";
	import { canAccessRoute, PERMISSIONS } from "src/config/permissions";

	export let location;

	let width;
	let message;
	let type;
	let breakPointWidth = 960;
	$: isCollapsed = width < breakPointWidth;
	let token = localStorage.getItem("token");
	let authenticated = Boolean(token);

	toastMessage.subscribe((value) => {
		message = value.message;
		type = value.type;
	});

	function toggleSidebar() {
		isCollapsed = !isCollapsed;
	}

	// `permission: null` means no permission is required; see canAccessRoute.
	const appRoutes = [
		{ path: "/dashboard", permission: null, component: Dashboard },
		{ path: "/jobs/*", permission: null, component: JobManagement },
		{ path: "/servicing/*", permission: null, component: Servicing },
		{
			path: "/issue-management/*",
			permission: null,
			component: IssueManagement,
		},
		{
			path: "/account/*",
			permission: PERMISSIONS.ACCOUNT,
			component: Account,
		},
		{
			path: "/car-management/*",
			permission: PERMISSIONS.CARS,
			component: CarManagement,
		},
		{
			path: "/carpark-management/*",
			permission: PERMISSIONS.CARPARKS,
			component: CarparkManagement,
		},
		{
			path: "/EV-charging-lot-management/*",
			permission: PERMISSIONS.CARPARKS,
			component: EvManagement,
			enabled: brand.isEVEnabled,
		},
		{
			path: "/blackout-management/*",
			permission: PERMISSIONS.BLACKOUT,
			component: BlackoutManagement,
		},
		{
			path: "/fuel-card-management/*",
			permission: PERMISSIONS.FUEL_CARD,
			component: FuelCardManagement,
		},
		{
			path: "/ev-account-management/*",
			permission: PERMISSIONS.FUEL_CARD,
			component: EvAccManagement,
		},
		{
			path: "/master-data/*",
			permission: PERMISSIONS.MASTER_DATA,
			component: MasterData,
		},
		{
			path: "/maintenance-repair/*",
			permission: PERMISSIONS.MAINTENANCE_REPAIR,
			component: MaintenanceRepair,
			enabled: isMnrEnabled,
		},
	];

	function resolveComponent(role, { permission, component, enabled }) {
		return canAccessRoute(role, permission) && (enabled ?? true)
			? component
			: NotFound;
	}
</script>

<div class="app" bind:clientWidth={width}>
	<div class="app-container">
		<div
			class={`sidebar-container ${
				isCollapsed ? "sidebar-collapse" : "sidebar-open"
			}`}
		>
			<Sidebar
				{location}
				{toggleSidebar}
				{isCollapsed}
				{breakPointWidth}
				{width}
			/>
		</div>
		<main
			class={`content-container ${
				isCollapsed
					? "content-container-collapse"
					: "content-container-open"
			} `}
		>
			<div class="container-fluid p-4">
				<AppBreadcrumb {location} />
				<Router url="/">
					<Route path="/issues/*">
						{#if canAccessRoute($userRole, null)}
							<Issues {location} />
						{:else}
							<NotFound />
						{/if}
					</Route>
					{#each appRoutes as route (route.path)}
						<Route
							path={route.path}
							component={resolveComponent($userRole, route)}
						/>
					{/each}
					<Route path="/not-found" component={NotFound} />
				</Router>
			</div>
			<CustomToast {message} {type} />
			<VersionModal />
		</main>
	</div>
</div>
